/* =========================
    IMPORTS & CORE PACKAGES
   ========================= */
import React, { createContext, useContext, useEffect, useState } from "react";
import { auth, db } from "../firebase";
import { onAuthStateChanged, signOut, signInWithEmailAndPassword } from "firebase/auth";
import { doc, getDoc } from "firebase/firestore";

/* ==============================
    AUTHENTICATION CONTEXT SETUP
   ============================== */

const AuthContext = createContext();

export function useAuth() {
  return useContext(AuthContext);
}

/* ================================
    AUTHENTICATION CUSTOM PROVIDER
   ================================ */

export function AuthProvider({ children }) {
  
  /* Session Authentication States */
  const [currentUser, setCurrentUser] = useState(null);
  const [userData, setUserData] = useState(null);
  const [loading, setLoading] = useState(true);

  /* Firebase Auth Actions */
  function login(email, password) {
    return signInWithEmailAndPassword(auth, email, password);
  }

  function logout() {
    return signOut(auth);
  }

  /* Authentication Observer & Sync logic */
  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, async (user) => {
      setCurrentUser(user);
      if (user) {
        const docRef = doc(db, "users", user.uid);
        const docSnap = await getDoc(docRef);
        if (docSnap.exists()) {
          setUserData(docSnap.data());
        }
      } else {
        setUserData(null);
      }
      setLoading(false);
    });
    return unsubscribe;
  }, []);

  /* Context Provider Render */
  const value = { currentUser, userData, login, logout };

  return (
    <AuthContext.Provider value={value}>
      {!loading && children}
    </AuthContext.Provider>
  );
}